module.exports = "<ng-container *ngIf=\"content | async as list\">\n    <!--<rows [rows$]=\"list.data\"></rows>-->\n    <list-marquee [item]=\"list\"></list-marquee>\n    <list [list]=\"list\" [fancy]=\"true\"></list>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/list-container/list-container.template.html
// module id = 858
// module chunks = 2